import React, { useState, useEffect } from "react";
import { Spin, Empty, Pagination } from "antd";
import { useSelector } from "react-redux";
import MyPromotionCard from "@/MyPromotionTabs/Card";
import { enumWalletProductGroupId } from "$DATA/balance.static";
import DatePicker from "@/UI/DatePicker";

const MyPromotionList = ({
    promotions = [], // 已处理好的数据从上层传入
    loading = false,
    type, // 组件类型
    pageSize = 9, // 每页数量
    renderImportantNote, // 提示文字
    onCardActionClick, // 卡片按钮事件处理
    lastUpdatedTime, // 更新时间（外部传入）
    showTabs = false, // 是否显示 Tab
    showDatePicker = false, // 是否显示 DatePicker
    dateRange,
    onDateChange,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState("TOTAL");
    const [showMoreMenuId, setShowMoreMenuId] = useState(null);

    useEffect(() => {
        setShowMoreMenuId(null);
    }, [selectedCategory, currentPage]);
    
    const handleMoreClick = (playerBonusId) => {
        Pushgtagdata(
            "Bonus",
            "Click Bonus Kebab Menu",
            "Bonus_Cancel_Bonus_Popup_C_Confirm"
        );
        setShowMoreMenuId((prev) => (prev === playerBonusId ? null : playerBonusId));
    };

    // 从 Redux 获取 balances（分类数据）
    const balanceInfo = useSelector((state) => state.balance.balanceInfo);
    // 若 `walletProductGroupId` 為 `TOTAL.ID`，則將 `walletProductGroupName` 設為 "ทั้งหมด"
    const balances = balanceInfo?.balances?.map((category) => 
        category?.walletProductGroupId === enumWalletProductGroupId.TOTAL.ID
            ? { ...category, walletProductGroupName: "ทั้งหมด" }
            : category
    ) || [];

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleCategoryChange = (categoryCode) => {
        const categoryData = enumWalletProductGroupId?.[categoryCode];
        const piwikCategoryName = categoryData?.piwikName || "";

        // 發送 Piwik 追蹤事件
        Pushgtagdata(
            "Bonus",
            type === "inProgress" ? "Choose Bonus Category" : "Filter Archived Bonus",
            type === "inProgress" ? "Bonus_C_FilterCategory" : "Bonus_Archived_C_Category",
            false,
            [
                {
                    customVariableKey: type === "inProgress" ? "Bonus_C_FilterCategory" : "Bonus_Archived_C_Category",
                    customVariableValue: piwikCategoryName,
                },
            ]
        );

        // 更新狀態
        setSelectedCategory(categoryCode);
        setCurrentPage(1); // 切換分類時重置頁碼
    };

    // 按分类过滤数据
    const filteredCategoryData =
        selectedCategory === "TOTAL"
            ? promotions
            : promotions.filter((item) => item.productGroup === selectedCategory);

    const paginatedData = filteredCategoryData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    return (
        <Spin spinning={loading} tip="กำลังโหลด กรุณารอสักครู่..." size="large">
            <div className={`my-promotion-list my-promotion-list-${type}`}>
                {(showTabs || showDatePicker) && (
                    <div div className="filters-container">
                        {/* 分类 Tab */}
                        {showTabs &&
                            balances.length > 0 &&
                        !(type === "inProgress" && promotions.length === 0) && (
                                <div className="category-tabs">
                                    {balances.map((category) => (
                                        <button
                                            key={category.walletProductGroupId}
                                            className={`category-tab ${
                                                category.walletProductGroupCode ===
                                                selectedCategory
                                                    ? "active"
                                                    : ""
                                            }`}
                                            onClick={() =>
                                                handleCategoryChange(
                                                    category.walletProductGroupCode
                                                )
                                            }
                                        >
                                            {category.walletProductGroupName}
                                        </button>
                                    ))}
                                </div>
                            )}
                        {/* 日期选择器 */}
                        {showDatePicker && (
                            <DatePicker
                                selectedDate={dateRange.from}
                                onDateChange={onDateChange}
                            />
                        )}
                    </div>
                )}

                {filteredCategoryData.length === 0 ? (
                    <Empty
                        image={"/th/img/img-no-record.svg"}
                        className="big-empty-box"
                        description={
                            type === "completed"
                                ? "ขณะนี้ไม่มีบันทึกโบนัส"
                                : "ไม่มีโบนัส"
                        }
                    />
                ) : (
                    <>
                        {/* 更新时间 */}
                        {lastUpdatedTime && (
                            <p className="last-updated">
                                เวลาที่อัปเดตล่าสุด : {lastUpdatedTime}
                            </p>
                        )}

                        {/* 卡片区域 */}
                        <div className="my-promotion-card-container">
                            {paginatedData.map((item, index) => (
                                <MyPromotionCard
                                    key={`${selectedCategory}_${currentPage}_${item.participantId || index}`}
                                    data={item}
                                    type={type}
                                    onActionClick={(data, actionType) =>
                                        onCardActionClick(data, actionType)
                                    }
                                    showMoreMenuId={showMoreMenuId}
                                    onMoreClick={handleMoreClick}
                                />
                            ))}
                        </div>

                        {/* 分页 */}
                        <Pagination
                            className="custom-pagination"
                            current={currentPage}
                            hideOnSinglePage={true}
                            pageSize={pageSize}
                            total={filteredCategoryData?.length}
                            onChange={handlePageChange}
                            itemRender={(page, type, originalElement) => {
                                if (type === "prev") {
                                    return (
                                        <img
                                            src="/th/img/icon/gray-arrow.svg"
                                            alt="left arrow"
                                            style={{ transform: "rotate(-90deg)" }} // 左箭头
                                        />
                                    );
                                }
                                if (type === "next") {
                                    return (
                                        <img
                                            src="/th/img/icon/gray-arrow.svg"
                                            alt="right arrow"
                                            style={{ transform: "rotate(90deg)" }} // 右箭头
                                        />
                                    );
                                }
                                return originalElement;
                            }}
                        />

                        {/* 提示文字 */}
                        {renderImportantNote && renderImportantNote()}
                    </>
                )}
            </div>
        </Spin>
    );
};

export default MyPromotionList;
